import React, { useState, useEffect } from 'react';

export default function RoutesPage({ apiUrl }) {
  const [routes, setRoutes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${apiUrl}/api/routes`)
      .then(r => r.json())
      .then(d => { setRoutes(d); setLoading(false); })
      .catch(e => { console.error(e); setLoading(false); });
  }, [apiUrl]);

  if (loading) return <div style={{ padding: '20px' }}>Loading...</div>;

  return <div style={{ padding: '20px' }}><h1>Routes</h1><p>Total Routes: {routes.length}</p></div>;
}